<template>
  <div class="relative flex h-screen w-full flex-col items-center overflow-hidden bg-base dark:bg-background-dark">

    <!-- Top Navigation Bar -->
    <header class="flex h-20 w-full flex-shrink-0 items-center justify-center border-b border-content/10 px-4 md:px-10">
      <div class="flex w-full max-w-5xl items-center justify-between">
        <div class="flex items-center gap-4 text-content">
          <h1 class="text-content text-lg font-bold leading-tight tracking-[-0.015em]">{{ $t('login.title') }}</h1>
        </div>
      </div>
    </header>

    <!-- Main Content (이 영역만 스크롤) -->
    <main class="no-scrollbar flex w-full flex-1 flex-col items-center justify-start overflow-y-auto p-4 py-8">
      <div class="w-full max-w-2xl rounded-xl bg-surface dark:bg-surface/50 p-6 md:p-10 border border-line dark:border-roundBorder">

        <!-- Page Heading -->
        <div class="mb-8 text-center">
          <p class="text-content text-3xl md:text-4xl font-black leading-tight tracking-[-0.033em]">{{ $t('account.agree.title') }}</p>
          <p class="text-gray-400 dark:text-muted text-base font-normal leading-normal mt-2">{{ $t('account.agree.titleSub') }}</p>
        </div>

        <!-- Progress Steps -->
        <div class="flex justify-center gap-2 mb-8">
          <div class="px-4 py-2 rounded-lg bg-primary text-white text-grid-btn font-bold">{{ $t('account.common.agree') }}</div>
          <div class="px-4 py-2 rounded-lg bg-content/5 text-muted text-grid-btn">{{ $t('account.common.info') }}</div>
          <div class="px-4 py-2 rounded-lg bg-content/5 text-muted text-grid-btn">{{ $t('account.common.complete') }}</div>
        </div>

        <!-- Privacy Policy Card -->
        <div class="mb-6">
          <div class="rounded-lg border dark:border-roundBorder bg-surface overflow-hidden">
            <div class="bg-line px-4 py-3 border-b border-surface-3">
              <h3 class="text-content text-base font-bold">개인정보 처리방침</h3>
            </div>
            <div class="p-4 max-h-96 overflow-y-auto text-sm text-gray-300 dark:text-muted leading-relaxed space-y-4">
              <div>
                <p class="font-semibold text-content mb-2">1. 개인정보의 처리 목적</p>
                <p>&lt;(주)메타덱스터&gt;('www.mdtdexter.com'이하 '메타덱스터') 은 다음의 목적을 위하여 개인정보를 처리하고 있으며, 다음의 목적 이외의 용도로는 이용하지 않습니다.</p>
                <p>– 고객 가입의사 확인, 고객에 대한 서비스 제공에 따른 본인 식별.인증, 회원자격 유지.관리, 물품 또는 서비스 공급에 따른 금액 결제, 물품 또는 서비스의 공급.배송 등</p>
              </div>

              <div>
                <p class="font-semibold text-content mb-2">2. 개인정보의 처리 및 보유 기간</p>
                <p>① '메타덱스터'은 정보주체로부터 개인정보를 수집할 때 동의 받은 개인정보 보유․이용기간 또는 법령에 따른 개인정보 보유․이용기간 내에서 개인정보를 처리․보유합니다.</p>
                <p>② 구체적인 개인정보 처리 및 보유 기간은 다음과 같습니다.</p>
                <p>– 고객 가입 및 관리 : 회원가입 및 회원 관리</p>
                <p>– 보유 기간 : 가입 후 5년</p>
              </div>

              <div>
                <p class="font-semibold text-content mb-2">3. 정보주체와 법정대리인의 권리·의무 및 그 행사방법</p>
                <p>이용자는 개인정보주체로써 다음과 같은 권리를 행사할 수 있습니다.</p>
                <p>① 정보주체는 '메타덱스터' 에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
                <p>1. 개인정보 열람요구</p>
                <p>2. 오류 등이 있을 경우 정정 요구</p>
                <p>3. 삭제요구</p>
                <p>4. 처리정지 요구</p>
              </div>

              <div>
                <p class="font-semibold text-content mb-2">4. 처리하는 개인정보의 항목 작성</p>
                <p>① '메타덱스터'은 다음의 개인정보 항목을 처리하고 있습니다.</p>
                <p>&lt;'메타덱스터'에서 수집하는 개인정보 항목&gt;</p>
                <p>'메타덱스터' 회원 가입 및 고객 문의 시, 제공 동의를 해주시는 개인정보 수집 항목입니다.</p>
                <p class="font-semibold">■ 회원 가입 시(회원)</p>
                <p>– 필수항목 : 성별, 생년</p>
                <p>– 선택항목 : 이름, 이메일</p>
                <p>– 수집목적 : 메타덱스터 회원관리 및 마케팅</p>
                <p>– 보유기간 : 가입 후 5년 또는 동의철회 시 지체없이 파기</p>
                <p>② '메타덱스터'은 만 14세 미만 아동의 개인정보를 보호하기 위하여 회원가입은 만14세 이상만 가능하도록 함으로써 아동의 개인정보를 수집하지 않습니다.</p>
              </div>

              <div>
                <p class="font-semibold text-content mb-2">5. 개인정보의 파기</p>
                <p>'메타덱스터'은 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.'</p>
                <p class="font-semibold">-파기절차</p>
                <p>이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.</p>
                <p class="font-semibold">-파기기한</p>
                <p>이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.</p>
              </div>

              <div>
                <p class="font-semibold text-content mb-2">6. 개인정보 자동 수집 장치의 설치•운영 및 거부에 관한 사항</p>
                <p>① '메타덱스터'은 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
                <p class="font-semibold">▶ 개인정보 보호책임자</p>
                <p>성명 : 손성웅</p>
                <p>직책 : 팀장</p>
                <p>연락처 : 02-2057-0117, help@mdtdexter.com</p>
                <p>※ 개인정보 보호 담당부서로 연결됩니다.</p>
                <p>② '메타덱스터'의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다.</p>
                <p>'메타덱스터'은 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.</p>
              </div>

              <div>
                <p class="font-semibold text-content mb-2">7. 개인정보 처리방침 변경</p>
                <p>① 이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.</p>
              </div>

              <div>
                <p class="font-semibold text-content mb-2">8. 개인정보의 안전성 확보 조치</p>
                <p>'메타덱스터'은 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.</p>
                <p>① 개인정보 취급 직원의 최소화 및 교육</p>
                <p>개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하여 개인정보를 관리하는 대책을 시행하고 있습니다.</p>
                <p>② 해킹 등에 대비한 기술적 대책</p>
                <p>'메타덱스터'은 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.</p>
                <p>③ 개인정보의 암호화</p>
                <p>이용자의 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.</p>
                <p>④ 접속기록의 보관 및 위변조 방지</p>
                <p>개인정보처리시스템에 접속한 기록을 최소 6개월 이상 보관, 관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록 보안기능 사용하고 있습니다.</p>
                <p>⑤ 개인정보에 대한 접근 제한</p>
                <p>개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여,변경,말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.</p>
              </div>

              <div>
                <p class="font-semibold text-content mb-2">9. 정보주체의 권익침해에 대한 구제방법</p>
                <p>아래의 기관은 (주)메타덱스터 와는 별개의 기관으로서, '메타덱스터'의 자체적인 개인정보 불만처리, 피해구제 결과에 만족하지 못하시거나 보다 자세한 도움이 필요하시면 문의하여 주시기 바랍니다.</p>
                <p class="font-semibold">▶ 개인정보 침해신고센터 (한국인터넷진흥원 운영)</p>
                <p>– 소관업무 : 개인정보 침해사실 신고, 상담 신청</p>
                <p>– 홈페이지 : privacy.kisa.or.kr</p>
                <p>– 전화 : (국번없이) 118</p>
                <p>– 주소 : (58324) 전남 나주시 진흥길 9(빛가람동 301-2) 3층 개인정보침해신고센터</p>
                <p class="font-semibold">▶ 개인정보 분쟁조정위원회</p>
                <p>– 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)</p>
                <p>– 홈페이지 : www.kopico.go.kr</p>
                <p>– 전화 : (국번없이) 1833-6972</p>
                <p>– 주소 : (03171)서울특별시 종로구 세종대로 209 정부서울청사 4층</p>
                <p>▶ 대검찰청 사이버범죄수사단 : 02-3480-3573 (www.spo.go.kr)</p>
                <p>▶ 경찰청 사이버안전국 : 182 (http://cyberbureau.police.go.kr)</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Checkboxes -->
        <div class="flex flex-col gap-4 mb-6">
          <div class="flex items-center gap-3 p-4 rounded-lg bg-content/5 dark:bg-base border dark:border-roundBorder">
            <input
              v-model="allSelected"
              type="checkbox"
              id="selectAll"
              class="app-check h-5 w-5 rounded cursor-pointer"
            />
            <label for="selectAll" class="text-base font-bold text-content cursor-pointer">{{ $t('account.agree.allAgree') }} </label>
          </div>

          <div class="flex items-center gap-3 p-3 rounded-lg hover:bg-content/5 transition-colors">
            <input
              v-model="selectList"
              type="checkbox"
              id="privacy"
              value="privacy"
              class="app-check h-5 w-5 rounded cursor-pointer"
            />
            <label for="privacy" class="text-sm text-gray-300 dark:text-muted cursor-pointer">
              {{ $t('account.agree.termsOfService') }}
            </label>
          </div>

          <div class="flex items-center gap-3 p-3 rounded-lg hover:bg-content/5 transition-colors">
            <input
              v-model="selectList"
              type="checkbox"
              id="age"
              value="age"
              class="app-check h-5 w-5 rounded cursor-pointer"
            />
            <label for="age" class="text-sm text-gray-300 dark:text-muted cursor-pointer">
              {{ $t('account.agree.privacyPolicy') }}
            </label>
          </div>
        </div>

        <!-- Next Button -->
        <div class="pt-4">
          <button
            @click="nextLevel()"
            :disabled="selectList.length < 2"
            :class="[
              'flex w-full cursor-pointer items-center justify-center overflow-hidden rounded-lg h-14 px-4 text-grid-btn font-bold leading-normal tracking-[0.015em]',
              selectList.length >= 2 ? 'bg-primary text-content hover:bg-primary/90' : 'bg-primary/40 text-white/60 cursor-not-allowed'
            ]"
          >
            <span class="truncate">Next</span>
          </button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "JoinAgree",
  data() {
    return {
      checkList: ['privacy','age'],
      selectList: []
    };
  },
  mounted() {
    // 회원가입 진입 시 URL param client=unity 면 localStorage 에 저장.
    // (약관→정보입력→완료 다단계 이동 중 URL query 가 유실되므로, 완료 페이지에서 이 값으로 모바일 복귀 판단)
    const client = new URLSearchParams(window.location.search).get('client');
    if (client === 'unity' || client === 'kogas') {
      try { localStorage.setItem('signupClient', client); } catch (e) { /* 무시 */ }
    }
  },
  methods: {
    nextLevel() {
      if(this.selectList.length >= 2){
        this.$router.push('/signup/inputInfo');
      } else {
        alert("모든 항목에 동의해주세요.");
      }
    },
  },
  computed: {
      allSelected: {
        get: function() {
          return this.checkList.length === this.selectList.length;
        },
        set: function(e) {
          this.selectList = e ? this.checkList : [];
        },
      },
    },
}
</script>

<style scoped>
/* 회원가입 체크박스: 전역 _inputs.scss 의 input[type=checkbox]::before(체크 시 인디고 #3f51b5 채움) 제거 —
   색 채움 없이 테두리 박스 + 파란 체크마크만 유지 (로그인 아이디저장과 동일 처리) */
.app-check {
  appearance: none !important;
  -webkit-appearance: none !important;
  width: 1.25rem !important;
  height: 1.25rem !important;
  border: 1.5px solid rgb(var(--c-muted)) !important;
  border-radius: 4px !important;
  background-color: transparent !important;
  background-image: none !important;
  cursor: pointer;
}
.app-check:checked {
  border-color: #137fec !important;
  background-color: transparent !important;
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M3 8l3.5 3.5L13 5' stroke='%23137fec' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e") !important;
  background-size: 88% 88% !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
}
.app-check:focus,
.app-check:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}
.app-check::before {
  display: none !important;
  content: none !important;
}

/* 스크롤 기능은 유지하고 스크롤바만 숨김 */
.no-scrollbar {
  -ms-overflow-style: none;   /* IE, 구 Edge */
  scrollbar-width: none;      /* Firefox */
}
.no-scrollbar::-webkit-scrollbar {
  display: none;              /* Chrome, Edge, Safari */
}
</style>